module.exports = __webpack_public_path__ + "img/existing-resources-2-1.9b12431e.jpg";